import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Alert, Box, Button, Divider, Link, Typography,TextField, LinearProgress, CircularProgress, Modal, Tooltip} from "@mui/material";
import { useState } from "react";
import { ColorModeContext, useMode } from "../theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { Topbar } from '../layouts/Topbar';
import Sidebarr from '../layouts/Sidebar';
import Header from "../components/Header";
import { api } from '../api';
import { fetchToken } from '../auth/Token';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import NavigateBeforeRoundedIcon from '@mui/icons-material/NavigateBeforeRounded';
import SavingsDetails from '../components/SavingsDetails';
import LoansDetails from '../components/LoansDetails';
import SharesDetails from '../components/SharesDetails';
// import CommodityDetails from '../components/CommodityDetails';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import CreateSavings from '../components/CreateSavings';
import CreateLoans from '../components/CreateLoans';
import CreateShares from '../components/CreateShares';
import CreateCommodities from '../components/CreateCommodities';
import CommodityDetails from '../components/CommodityDetails';
import EditIcon from '@mui/icons-material/Edit';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useFormik, validateYupSchema } from 'formik';
import * as Yup from 'yup';
import CreateSeasons from '../components/CreateSeasons';
import SeasonDetails from '../components/SeasonDetails'
import EquipDetails from '../components/EquipDetails';
// import WareHouse from './Warehouse';
import { toast } from 'sonner';

export default function PassBook({isOnline}) {
    const location = useLocation();
    const ID = location.state && location.state.Member_id;
    const Name = location.state && location.state.Fullname;
    const Psb = location.state && location.state.Psb;
    const [accounts, setAccounts] = useState({});
    const [open_acc, setOpen_acc] = useState();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const navigate = useNavigate();
    const open = Boolean(anchorEl);
    const [saveValue, setSaveValue] = useState(0)
    const [loanValue, setLoanValue] = useState(0);
    const [prodValue, setProdValue] = useState(0);
    const [equipValue, setEquipValue] = useState(0);
    const [shareValue, setShareValue] = useState(0);
    const [commodityValue, setCommodityValue] = useState(0);
    const [passbookValue, setPassbookValue] = useState(0) 
    const [alert, setAlert] = useState()
    const [assid, setidddd] = useState(null);
    const [original_p, setOriginal_P] = useState('');
    const [hu, setHu] = useState(false);
    const [init,setInit] = useState('');
    const [loading, setLoading] = useState(false)
    // const [season_start, setSeason_start] = useState('')
    // const [season_end, setSeason_end] = useState('')
    // const [season_name, setSeason_name] = useState('')

    const ActivateIt = () => {
      const data = new FormData()
      data.append('association_member_id', Psb)
      data.append('member_id', ID)

      api.post('/account/member/equipment/activate', data,{
        headers: {
          Authorization: 'Bearer '+ fetchToken()
        }
      }).then(function(response){
        toast.success(response.data);
        ;
        fetchAccounts();
      }).catch(function(error){
        console.log(error)
      })
    }

    const fetchAccounts = async () => {
      const cacheKey = `/account/accounts/${Psb}`;
      const cachedData = localStorage.getItem(cacheKey);
    
      if (!isOnline) {
        setAccounts(JSON.parse(cachedData));
      } else {
        try {
          const response = await api.get(`/account/accounts/${Psb}`, {
            headers: {
              Authorization: 'Bearer ' + fetchToken(),
            },
          });
          
          localStorage.setItem(cacheKey, JSON.stringify(response.data));
    
          setAccounts(response.data);
        } catch (error) {
          console.log(error);
        }
      }
    };
    

    const handelpp = () => {
      setHu(true)
    }
    
    const closeFormm = () => {
      setHu(false);
      memik.handleReset();
    }

          const memik = useFormik({
              initialValues: {
                new_passbook_id: original_p,
            },
            validationSchema: Yup.object({
              new_passbook_id: Yup.string().matches(new RegExp(`^${init}\\d{3}$`), {
                message: `Invalid format. Should start with the Kind first Character, then Savings Groups first two characters(${init}) followed by three digit.`,})
            }),
            onSubmit: (values) => {
                setLoading(true)
                const j = new FormData()
                j.append('association_member_id', Psb)
                j.append('new_passbook_id', values.new_passbook_id)

                api.post('/members/update/passbook_id', j,{
                  headers: {
                    Authorization: 'Bearer '+ fetchToken()
                  }
                }).then(function(response){
                  toast.success(response.data)
                  fetch_p_Id();
                  closeFormm();
                }).catch(function(error){
                  console.log(error)
                }).finally(function (){
                  setLoading(false)
                });

            }
          })
          const [big_details, setBig_Details] = useState([])
      const fetchAssociationId = () => {
        api.get(`/association/get/association_id/${Psb}`,{
          headers: {
            Authorization: 'Bearer '+ fetchToken()
          }
        }).then(function(response){
          setidddd(response.data?.dd);
          setBig_Details(response.data?.details)
        }).catch(function(error){
          console.log(error)
        })
      }

      const fetch_p_Id = () => {
        api.get(`/members/member/passbook_id/${Psb}`,{
          headers: {
            Authorization: 'Bearer '+ fetchToken()
          }
        }).then(function(response){
          setOriginal_P(response.data?.pass_id);
          setInit(response.data?.initials);
        }).catch(function(error){
          console.log(error)
        })
      }
      useState(()=>{
        fetchAssociationId();
        fetch_p_Id();
      },[])


    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
      setAnchorEl(null);
    };
      
    useEffect(() => {
        fetchAccounts()
    }, [])

    const Item = styled(Paper)(({ theme }) => ({
      backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
      ...theme.typography.body2,
      padding: theme.spacing(1),
      textAlign: 'center',
      color: theme.palette.text.secondary,
    }));
    
    const Itemf = styled(Paper)(({ theme }) => ({
      backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
      ...theme.typography.body2,
      padding: theme.spacing(1),
      borderRadius: '20px'
    }));
    // console.log(accounts.Savings_acc)
    const handleSave = (id,name,balance) => {
      if (open_acc == null)
      {
        setOpen_acc(<SavingsDetails fetchAccounts={fetchAccounts} ID= {id} member_id={ID} name={name} balance={balance} setOpen_acc={setOpen_acc}/>)
        setAlert()
      }else{
        toast.warning("Close Current tab before opening another tab")
        
      }
    }

    const handleLoan = (id,name) => {
      if (open_acc == null) 
      {
        setOpen_acc(<LoansDetails fetchAccounts={fetchAccounts} ID={id} name={name} setOpen_acc={setOpen_acc}/>)
        setAlert()
      }else{
        toast.warning("Close Current tab before opening another tab")
        
      }
    }

    const handleProduction = (id, name) => {
      if (open_acc == null) 
      {
        setOpen_acc(<SeasonDetails society={big_details.society}
            kind={big_details.association_type}
            association={big_details.association_name}
            passbook={original_p}
            member={Name}
            savings_acc={accounts.Savings_acc}
            fetchAccounts={fetchAccounts}
            name={name} 
            ID={id} 
            setOpen_acc={setOpen_acc}
            society_id={big_details.id}/>)
        setAlert()
      }else{
        toast.warning("Close Current tab before opening another tab")
        
      }
    }

    const handleEquip = (id, name, balance) => {
      if (open_acc == null) 
      {
        setOpen_acc(<EquipDetails 
            society={big_details.society}
            kind={big_details.association_type}
            association={big_details.association_name}
            passbook={original_p}
            member={Name}
            savings_acc={accounts.Savings_acc}
            fetchAccounts={fetchAccounts}
            name={name} 
            ID={id} 
            setOpen_acc={setOpen_acc}
            current_balance={balance}
            society_id={big_details.id}/>)
        setAlert()
      }else{
        toast.warning("Close Current tab before opening another tab")
        
      }
    }

    const handleShare = (id,name) => {
      if (open_acc == null)
      {
        setOpen_acc(<SharesDetails fetchAccounts={fetchAccounts} name={name} ID={id} setOpen_acc={setOpen_acc}/>)
        setAlert()
      }else{
        toast.warning("Close Current tab before opening another tab")
        
      }
    }

    const handleCommodity = (id,name) => {
      if (open_acc == null)
      {
        setOpen_acc(<CommodityDetails
          society={big_details.society}
          kind={big_details.association_type}
          association={big_details.association_name}
          passbook={original_p}
          member={Name}
          fetchAccounts={fetchAccounts}
          name={name} 
          ID={id} 
          setOpen_acc={setOpen_acc}
          society_id={big_details.id}
        />)
        setAlert()
      }else{
        toast.warning("Close Current tab before opening another tab")
        
      }
    }


    const handleNewSavings = () => {
      setOpen_acc()
      setOpen_acc(<CreateSavings accounts={accounts.Savings_acc} fetchAccounts={fetchAccounts} setOpen_acc={setOpen_acc} member_id={ID} Psb={Psb} />)
    };

    const handleNewLoans = () => {
      setOpen_acc()
      setOpen_acc(<CreateLoans accounts={accounts.Loans_acc} fetchAccounts={fetchAccounts} setOpen_acc={setOpen_acc} member_id={ID} Psb={Psb}/>)
    };

    const handleNewShares = () => {
      setOpen_acc()
      setOpen_acc(<CreateShares accounts={accounts.Shares_acc} fetchAccounts={fetchAccounts} setOpen_acc={setOpen_acc} member_id={ID} Psb={Psb} />)
    };

    const handleNewCommoddities = () => {
      setOpen_acc()
      setOpen_acc(<CreateCommodities accounts={accounts.Commodity_acc} fetchAccounts={fetchAccounts} setOpen_acc={setOpen_acc} member_id={ID} Psb={Psb} />)
    };

    const handleNewSeason = () => {
      setOpen_acc()
      setOpen_acc(<CreateSeasons accounts={accounts.Production_acc} fetchAccounts={fetchAccounts} setOpen_acc={setOpen_acc} member_id={ID} Psb={Psb} />)
   }
    
  useEffect(() => {
    if (accounts.Savings_acc) {
      let totalSavingsValue = 0;
      accounts.Savings_acc.forEach((savingsItem) => {
        totalSavingsValue += savingsItem.Current_Balance;
      });
      setSaveValue(totalSavingsValue);
    }
  }, [accounts.Savings_acc])
    

    useEffect(() => {
      if (accounts.Loans_acc) {
        let totalLoanValue = 0;
        accounts.Loans_acc.forEach((loanItem) => {
          totalLoanValue += loanItem.current_balance;
        });
        setLoanValue(totalLoanValue);
      }
    }, [accounts.Loans_acc]);

    useEffect(() => {
      if (accounts.Production_acc) {
        let totalProductionValue = 0;
        accounts.Production_acc.forEach((prodItem) => {
          totalProductionValue += prodItem.current_balance;
        });
        setProdValue(totalProductionValue);
      }
    }, [accounts.Production_acc]);

    useEffect(() => {
      if (accounts.Equipment_acc) {
        let totalProductionValue = 0;
        accounts.Equipment_acc.forEach((prodItem) => {
          totalProductionValue += prodItem.current_balance;
        });
        setEquipValue(totalProductionValue);
      }
    }, [accounts.Equipment_acc]);
    

    useEffect(() => {
      if (accounts.Shares_acc) {
        let totalShareValue = 0;
        accounts.Shares_acc.forEach((shareItem) => {
          totalShareValue += shareItem.current_balance;
        });
        setShareValue(totalShareValue);
      }
    }, [accounts.Shares_acc]); 
    
    useEffect(() => {
      if (accounts.Commodity_acc) {
        let totalCommodityValue = 0;
        accounts.Commodity_acc.forEach((commodityItem) => {
          totalCommodityValue += commodityItem.Amount_value;
        });
        setCommodityValue(totalCommodityValue);
      }
    }, [accounts.Commodity_acc]); 

    useEffect(() => {
      setPassbookValue(
        saveValue + shareValue + commodityValue  +  loanValue - (prodValue + equipValue)
      ) 
    }, [saveValue,  shareValue, loanValue, commodityValue, prodValue, equipValue])

    const handleClickAsso = () => {
      fetchAssociationId();
      // console.log(assid)
      try {
         api.get(`/association/${assid}`,{
          headers :{
            Authorization: 'Bearer '+ fetchToken()
          }
        }).then(function (response){
            navigate('/association/', { state: { responseData: response.data } })
        }).catch(function (error){
          console.log(error)
        });
      } 
      catch(error){
      console.log(error )
    };
  };

  const currencyFormat = new Intl.NumberFormat('en-GH', {
    style: 'currency',
    currency: 'GHS',
  });
  return (
      <div className="app">
        <main className="content">
            <Box sx={{m:5}}>
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Header title="Passbook" subtitle="Accounts and details" />
              </Box>
              {
                accounts !== null
                ?
                <Grid container spacing={2}>
              {/* name of member and maybe the passbook number as header here */}
              <Grid item xs={12} md={12}>
                <Itemf>
                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{textAlign: 'center',}} variant='h3'><b>{`${Name}'s Passbook`}</b></Typography>
                  {alert}
                  <div style={{ display: 'flex' }}>
                    <EditIcon onClick={handelpp}/>
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"  variant='h5' sx={{ color: 'darkblue', ml:1 }}>Passbook Number: <b>{original_p}</b></Typography> 
                  </div>
                  <div>
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" fontStyle='Italic' variant='body2'>Society: <b style={{color:'black'}}>{big_details.society}</b></Typography>
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" fontStyle='Italic' variant='body2'>Kind: <b style={{color:'black'}}>{big_details.association_type}</b></Typography>
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" fontStyle='Italic' variant='body2'>Savings Groups: <b style={{color:'black'}}>{big_details.association_name}</b></Typography>
                  </div>
                </Itemf>
              </Grid>
              <Divider sx={{ mb: '10px', mt:'10px' }} variant='middle' />
                {/* accounts and accounts info will also be here */}
              <Grid container spacing={1} sx={{ marginLeft: '10px' }}>
                {/* All account names and total balances will be here */}
                <Grid item xs={12}>
                  <Button
                    variant='contained'
                    color='secondary'
                    onClick={handleClickAsso}
                    sx={{   m:1, 
                      borderRadius:4,
                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                      minWidth: 0,
                      '&:hover': {
                      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                      backgroundColor:'#80ed99',
                      color:'#000'
                      },
                   }} 
                    startIcon={<NavigateBeforeRoundedIcon />}
                  >
                    Back to Savings Group 
                  </Button>
                  <Button
                    variant='contained'
                    id="demo-positioned-button"
                    aria-controls={open ? 'demo-positioned-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleClick}
                    sx={{   m:1, 
                      borderRadius:4,
                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                      minWidth: 0,
                      '&:hover': {
                      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                      backgroundColor:'#80ed99',
                      color:'#000'
                      },
                   }} 
                  > 
                  Activate new Account
                  </Button>
                  <Menu
                    id="demo-positioned-menu"
                    aria-labelledby="demo-positioned-button"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                  >
                    <MenuItem onClick={handleNewSavings}>Savings Account</MenuItem>
                    <MenuItem onClick={handleNewLoans}>Loans Account</MenuItem>
                    <MenuItem onClick={handleNewShares}>Shares Account</MenuItem>
                    <MenuItem onClick={handleNewCommoddities}>Join Warehouse</MenuItem>
                    <MenuItem onClick={handleNewSeason}>Production Loan</MenuItem>
                    <MenuItem onClick={handleClose}>Cancel</MenuItem>
                  </Menu>
                </Grid>
              <Grid item xs={12} md={4} sx={{ mb:15 }}>
                <>

                <Accordion sx={{ borderRadius:2, mb:2 }}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    display='flex'
                  >
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ mr: 'auto' }}><b>Savings Accounts</b></Typography>
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">Total Balance: <b>{currencyFormat.format(saveValue)}</b></Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                  <Divider sx={{ m: 1 }} />
                  {accounts.Savings_acc?.map((savingsItem, index) => (
                    <>
                      <div key={index} style={{ display:'flex' }}>
                        <Link
                            sx={{  mr: 'auto'}}
                            variant="h6"
                            underline="none"
                            component='button'
                            color="inherit"
                            onClick={() => handleSave(savingsItem.ID, savingsItem.Account_Name, savingsItem.Current_Balance)}
                        >
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{savingsItem.Account_Name}: </b></Typography>
                        </Link>
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{currencyFormat.format(savingsItem.Current_Balance)}</b></Typography>
                      </div>
                      <Divider variant='middle' sx={{marginBottom:'10px'}} />
                    </>
                  ))}
                  </AccordionDetails>
                </Accordion>
                <Accordion sx={{ borderRadius:2, mb:2 }}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                    display='flex'
                  >
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ mr: 'auto' }}><b>Cash Loans Accounts</b></Typography>
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">Total Balance: <b>{currencyFormat.format(loanValue)}</b></Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                  <Divider sx={{ m: 1 }} />
                  {accounts.Loans_acc?.map((savingsItem, index) => (
                    <>
                      <div key={index} style={{ display:'flex' }}>
                        <Link
                          sx={{  mr: 'auto'}}
                          variant="h6"
                          underline="none"
                          component='button'
                          color="inherit"
                          onClick={() => handleLoan(savingsItem.ID, savingsItem.account_name)}
                        >
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{savingsItem.account_name}: </b></Typography>
                       </Link>
                           <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{currencyFormat.format(savingsItem.current_balance)}</b></Typography>
                        </div>
                      <Divider variant='middle' sx={{marginBottom:'10px'}} />
                    </>
                  ))}
                  </AccordionDetails>
                </Accordion>

                <Accordion sx={{ borderRadius:2, mb:2 }}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                    display='flex'
                  >
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ mr: 'auto' }}><b>Production Loans Accounts</b></Typography>
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">Total Balance: <b>{currencyFormat.format(prodValue)}</b></Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                  <Divider sx={{ m: 1 }} />
                  
                  {accounts.Production_acc?.map((savingsItem, index) => (
                      <>
                      <div key={index} style={{ display:'flex' }}>
                        <Tooltip title={savingsItem.status}>
                          <Link
                            sx={{  mr: 'auto'}}
                            variant="h6"
                            underline="none"
                            component='button'
                            color="inherit"
                            onClick={() => handleProduction(savingsItem.ID, savingsItem.season_name)}
                        >
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{savingsItem.season_name}: </b></Typography>
                        </Link>
                        </Tooltip>
                        
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{currencyFormat.format(savingsItem.current_balance)}</b></Typography>
                      </div>
                      <Divider variant='middle' sx={{marginBottom:'10px'}} />
                    </>
                  ))}
                  </AccordionDetails>
                </Accordion>

                <Accordion sx={{ borderRadius:2, mb:2 }}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                    display='flex'
                  >
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ mr: 'auto' }}><b>Equipments Loans</b></Typography>
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">Total Balance: <b>{currencyFormat.format(equipValue)}</b></Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                        <Button
                          variant='contained'
                          onClick={ActivateIt}
                          disabled={accounts.Equip}
                          size='small'
                          sx={{   m:1, 
                              borderRadius:4,
                              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                              minWidth: 0,
                              '&:hover': {
                              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                              backgroundColor:'#80ed99',
                              color:'#000'
                              },
                          }}
                        >
                          Activate Equipment Loans
                        </Button>
                  
                  <Divider sx={{ m: 1 }} />
                  {accounts.Equipment_acc?.map((savingsItem, index) => (
                      <>
                      <div key={index} style={{ display:'flex' }}>
                        <Link
                            sx={{  mr: 'auto'}}
                            variant="h6"
                            underline="none"
                            component='button'
                            color="inherit"
                            onClick={() => handleEquip(savingsItem.ID, 'Equipment Loans', savingsItem.current_balance)}
                        >
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Equipment Loans: </b></Typography>
                        </Link>
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{currencyFormat.format(savingsItem.current_balance)}</b></Typography>
                      </div>
                    </>
                  ))}
                  </AccordionDetails>
                </Accordion>
                  
                <Accordion sx={{ borderRadius:2, mb:2 }}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel3a-header"
                    display='flex'
                  >
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ mr: 'auto' }}><b>Share Accounts</b></Typography>
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">Total Balance: <b>{currencyFormat.format(shareValue)}</b></Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                  <Divider sx={{ m: 1 }} />
                  {accounts.Shares_acc?.map((savingsItem, index) => (
                    <>
                      <div key={index} style={{ display:'flex' }}>
                        <Link
                            sx={{  mr: 'auto'}}
                            variant="h6"
                            underline="none"
                            component='button'
                            color="inherit"
                            onClick={() => handleShare(savingsItem.ID, savingsItem.account_name)}
                        >
                            
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{savingsItem.account_name}: </b></Typography>
                        </Link>
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{currencyFormat.format(savingsItem.current_balance)}</b></Typography>
                        </div>
                      <Divider variant='middle' sx={{marginBottom:'10px'}} />
                    </>
                  ))}
                  </AccordionDetails>
                </Accordion>

                <Accordion sx={{ borderRadius:2, mb:2 }}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                    sx={{ display:'flex', justifyContent:'space-between' }}
                  >
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ mr: 'auto' }}><b>Warehouses</b></Typography>
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">Total Cash Value: <b>{currencyFormat.format(commodityValue)}</b></Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                  <Divider sx={{ m: 1 }} />
                  {accounts.Commodity_acc?.map((savingsItem, index) => (
                    <>
                    <div key={index} style={{ display:'flex' }}>
                      <Link
                          sx={{  mr: 'auto'}}
                          variant="h6"
                          underline="none"
                          component='button'
                          color="inherit"
                          onClick={() => handleCommodity(savingsItem.ID, savingsItem.Warehouse_name)}
                      >
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{savingsItem.Warehouse_name}: </b></Typography>
                      </Link>
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">Commodities Cash Value: <b>{currencyFormat.format(savingsItem.Amount_value)}</b></Typography>
                    </div>
                    <Divider variant='middle' />
                    </>
                  ))}
                  </AccordionDetails>
                </Accordion>
                <>
                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Passbook Value</b> (SaA + ShA + CoA - LoA - PrA - EqA): <b>{currencyFormat.format(passbookValue)}</b> </Typography></>
                </>
              </Grid>
              {/* here for account's recent transaction when clicked */}
              <Grid item xs={12} md={8}>
                  {open_acc}
              </Grid>

              </Grid>

              </Grid>
              :
              <Box sx={{ width: '100%' }}>
                <LinearProgress />
              </Box>
              }

          
              
              <Dialog open={hu} onClose={closeFormm}>
                <form onSubmit={memik.handleSubmit}>
                <DialogTitle>Edit Passbook Number</DialogTitle>
                <DialogContent>
                
                <TextField
                    margin="dense"
                    size="small"
                    sx={{ borderRadius: 4, m:2 }}
                    name="new_passbook_id"
                    label="New Passbook number"
                    type="text"
                    value={memik.values.new_passbook_id}
                    onChange={memik.handleChange}
                    variant="standard"
                    onBlur={memik.handleBlur}
                    error={memik.touched.new_passbook_id && Boolean(memik.errors.new_passbook_id)}
                    helperText={memik.touched.new_passbook_id && memik.errors.new_passbook_id}
                />
                
                </DialogContent>
                <DialogActions>
                <Button
                    size='small'
                    onClick={closeFormm}
                    color='error'
                    variant='contained'
                    sx={{ m:2 }}
                >
                    Cancel
                </Button>
                <Button
                    variant='contained'
                    type='submit'
                    color='success'
                    size='small'
                    disabled={loading === true? true: false}
                    sx={{ m:2 }}
                >
                    {
                        loading === true ?
                        <Box sx={{ width: '100%' }}>
                            <CircularProgress />
                        </Box>
                        : "Change"
                    }
                </Button>
                </DialogActions>
                </form>
            </Dialog>
            </Box>
          </main>
        </div>
  );
};
